<template xmlns:v-popover="http://www.w3.org/1999/xhtml">
    <div class="scan-list" v-loading.fullscreen="isLoading" element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.6)">
        <div id="dwtcontrolContainer" style="position: absolute;visibility: hidden"></div>
        <div class="scan-list-container">
<!--            <div class="scan-list-content" :style="{padding: styleList[0].select ? '30px 40px' : '30px'}">-->
            <div class="scan-list-content" style="padding: 30px">
                <div class="scan-list-head">
                    <brainTitle :brain-title="brainTitle"></brainTitle>
                    <div v-show="!statusInterval" class="scan-list-head-history">
                        <div v-if="!historyDateRangeText" class="show-history" v-popover:popover>查看扫描历史</div>
                        <div v-if="historyDateRangeText" class="show-history-time">
                            <span v-popover:popover>扫描时间：{{historyDateRangeText}}</span>
                            <span class="el-icon-error" @click="clearHistoryRange"></span>
                        </div>
                        <el-popover
                                class="scan-history-popover"
                                ref="popover"
                                v-model="historyPopoverVisible"
                                placement="bottom"
                                trigger="click">
                            <div class="scan-history-popover-content">
                                <div class="scan-history-title">选择查看的时间范围</div>
                                <el-date-picker
                                        v-model="historyDateRange"
                                        type="datetimerange"
                                        align="right"
                                        class="scan-history-date"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        :default-time="['08:00:00', '22:00:00']">
                                </el-date-picker>
                                <div class="scan-history-bar">
                                    <input v-model="historySearchValue" class="scan-history-input" placeholder="试卷ID" type="tel">
                                    <button class="scan-history-btn" @click="submitRequestHistory">确定</button>
                                    <button class="scan-history-btn btn-cancel" @click="historyPopoverVisible = false">取消</button>
                                </div>
                            </div>
                        </el-popover>
                    </div>
                </div>
                <div class="scan-list-body">
                    <div class="scan-batch" v-for="(batch, key) in scanShowList" :key="key">
                        <div v-if="showTimeLine(key,batch)" class="scan-batch-title">
                            <span class="can-batch-title-block">{{batch.time || '--:--'}} 开始扫描</span>
                            <span class="can-batch-title-dash"></span>
                        </div>
                        <div class="scan-list-batch">
                            <template v-for="(single, index) in batch.list">
                                <single-scan v-if="isShowScan(key,single)"
                                             :key="single && single.pageNum ? single.pageNum : index"
                                             :scan-single="single"
                                             :isNormalPaper="['normal', 'quick'].includes($route.query.type)"
                                             :paperType="scanPaperType"
                                             :isSmall="styleList[1].select"
                                             @showPaperDialog="showPaperDialog"
                                             @showPaperCodeDialog="showPaperCodeDialog"
                                             @showCodeDialog="showCodeDialog"
                                             @deletePaper="deleteScanPaper(single)"
                                             class="scan-list-single">
                                </single-scan>
                            </template>
                            <div style="clear:both"></div>
                        </div>
                    </div>
                    <div v-show="showEmpty(scanShowList)" class="empty-content">
                        <img class="empty-img" src="../../assets/image/scan/empty-scan-icon.png" alt="">
                        <div class="empty-text">暂无试卷</div>
                        <div v-show="!historyDateRangeText" class="empty-tip">
                            <span>点击右下方按钮开始扫描</span>
                            <img class="empty-scan-icon" src="../../assets/image/scan/scan-tip-icon.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="scan-list-footer">
            <div class="scan-list-center">
                <div class="scan-foot-left">
                    <span class="scan-info">
                        <span>已扫描：</span>
                        <span class="scan-info-num">{{scanNum || 0}}</span>
                        <span class="scan-info-part">份</span>
                    </span>
                    <span class="scan-info">
                        <span class="scan-info-point"></span>
                        <span>上传成功：</span>
                        <span class="scan-info-num">{{scanRate || 0}}</span>
                        <span class="scan-info-percent">%</span>
                    </span>
                    <span class="scan-info">
                        <span class="scan-info-point scan-point-y"></span>
                        <span>上传失败：</span>
                        <span class="scan-info-num scan-num-y">{{scanErrNum || 0}}</span>
                        <span class="scan-info-part">份</span>
                    </span>
                    <div v-if="false" class="scan-type">
<!--                    <div class="scan-type">-->
                        <span class="span-type-title">试卷显示方式</span>
                        <span class="span-type-content">
                            <span v-for="(item,index) in styleList" :key="index" @click="changeStyle(item)" :class="{'span-type-option-active': item.select}" class="span-type-option">{{item.name}}</span>
                        </span>
                    </div>
                    <div class="scan-type">
                        <span class="span-type-title">显示异常试卷</span>
                        <brain-switch v-model="switchValue" @change="switchChange"></brain-switch>
                    </div>
                </div>
                <button v-show="!historyDateRangeText" :disabled="!DWObject" @click="scanAgain()" class="scan-btn">{{scanBatch === 0 ? '开始扫描' : '继续扫描'}}</button>
            </div>
        </div>
        <el-dialog :visible.sync="codeDialogVisible" custom-class="student-code" top="0" :show-close="false">
            <div class="code-row">
                <span class="code-row-name">学号</span>
                <input class="code-row-input" v-model="studentCodeValue" type="text" placeholder="请输入学号">
            </div>
            <div class="code-footer">
                <button @click="codeDialogVisible = false" class="code-btn code-cancel">取消</button>
                <button @click="submitCode(currentPaper, false)" class="code-btn code-submit">确认</button>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="paperCodeDialogVisible" custom-class="student-code" top="0" :show-close="false">
            <div class="code-row">
                <span class="code-row-name">编号</span>
                <input class="code-row-input" v-model="paperCodeValue" type="text" placeholder="请输入作业编号">
            </div>
            <div class="code-footer">
                <button @click="paperCodeDialogVisible = false" class="code-btn code-cancel">取消</button>
                <button @click="submitPaperCode(currentPaper)" class="code-btn code-submit">确认</button>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="paperDialogVisible" custom-class="student-paper" top="0" :show-close="false">
            <img class="paper-img" src="../../assets/image/scan/submit-page-icon.png" alt="">
            <div class="paper-title">
                <span class="paper-title-text">请确认该试卷是否属于</span>
<!--                <span v-show="!historyDateRangeText" class="paper-title-name">{{paperName}}</span>-->
<!--                <div v-show="historyDateRangeText" class="paper-name-list">-->
                <div class="paper-name-list">
                    <el-select v-model="paperName"
                               @change="changePaperName"
                               :disabled="Boolean(currentPaper.paperCode)"
                               class="paper-name-select"
                               placeholder="请选择">
                        <el-option
                                v-for="item in paperNameList"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="paper-page-title">该试卷页码为</div>
            <div class="paper-page-content">
                <div class="paper-page-option" v-for="(item,index) in pageList[0]" :key="index" @click="selectPage(item)" :class="{'paper-page-option-active': item.select}">{{item.name}}</div>
            </div>
            <div class="paper-page-content">
                <div class="paper-page-option" v-for="(item,index) in pageList[1]" :key="index" @click="selectPage(item)" :class="{'paper-page-option-active': item.select}">{{item.name}}</div>
            </div>
            <div class="paper-footer">
                <button @click="submitPaper(currentPaper)" class="paper-btn paper-submit">确认</button>
                <button @click="paperDialogVisible = false" class="paper-btn paper-cancel">取消</button>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="setPaperDialogVisible" custom-class="set-paper" top="0" :show-close="false">
            <img class="set-paper-img" src="../../assets/image/scan/empty-paper-icon.png" alt="">
            <div class="set-paper-title">请将试卷放入扫描仪送纸器，然后按确认按钮。</div>
            <div class="set-paper-tip">注意继续扫描后已经上传成功的试卷将不再显示</div>
            <div class="set-paper-footer">
                <button @click="submitScanAgain()" class="set-paper-btn set-paper-submit">确认</button>
                <button @click="setPaperDialogVisible = false" class="set-paper-btn set-paper-cancel">取消</button>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="scanLoadingDialogVisible" :close-on-press-escape="false" :close-on-click-modal="false" custom-class="scan-loading" top="0" :show-close="false">
            <img class="scan-loading-img" src="../../assets/image/classroom/list/list-background.png" alt="">
            <div class="scan-loading-title">正在扫描试卷，请等待片刻……</div>
            <div class="scan-loading-tip">已扫描 1 份</div>
        </el-dialog>
    </div>
</template>

<script>
    import Dynamsoft from 'dwt'
    import brainSwitch from '../../components/brainSwitch'
    import brainTitle from '../../components/brainTitle'
    import singleScan from './components/singleScan'
    export default {
        name: "scanList",
        data () {
            return {
                scanPaperType: '', // 扫描试卷类型
                brainTitle: '', // 扫描试卷类型文字
                switchValue: false,
                styleList: [{name: 'X4', select: false}, {name: 'X8', select: true}], // 试卷显示方式
                pageList: [],
                codeDialogVisible: false, // 学号确认弹窗
                paperCodeDialogVisible: false, // 试卷编号确认弹窗
                paperDialogVisible: false, // 试卷确认弹出
                setPaperDialogVisible: false, // 扫描仪无试卷弹窗
                scanLoadingDialogVisible: false, // 扫描loading 弹窗
                scanBatch: 0, // 扫描批次
                DWObject: null, // scan object
                scanNum: 0, // 扫描份数
                scanRate: 0, // 扫描成功率
                scanErrNum: 0, // 失败份数
                scanShowList: [], // 显示试卷列表
                scanBatchNumberCount: 0, // 每批次扫描统计
                scanOriginList: [], // 原试卷列表
                studentCodeValue: '', // 确认学号输入值
                paperCodeValue: '', // 确认试卷编号输入值
                paperName: '', //确认页码试卷名称
                paperNameList: [], //确认页码试卷名称列表
                currentPaper: '', //当前所选试卷
                sourceName: '', // 扫描仪型号名
                statusInterval: null, // 请求状态定时器
                uploadUrl:'', // 图片上传路径
                historyDateRange: '', // 查看历史扫描记录时间范围
                historyDateRangeText: '', // 查看历史扫描记录时间范围
                historySearchValue: '', // 查看历史扫描记录试卷Id
                historyPopoverVisible: false, // 历史试卷选择弹窗
                isLoading: false, // loading
                currentCode: 0,
                isBlue: false,
                timer: null
            }
        },
        components: {
            brainSwitch,
            brainTitle,
            singleScan
        },
        created () {
            // this.brainTitle = this.$route.query.isNormal ? '标准试卷扫描' : '个性化作业扫描';
            // const uploadUrl = this.$route.query.isNormal ? `/api/tk/composedPaper/answerSheetLocate` : `/api/tk/composedPaper/answerSheetLocateForQbot`;
            this.scanPaperType = this.$route.query.type;
            switch (this.$route.query.type) {
                case 'normal':
                    this.brainTitle = '答题卡试卷扫描';
                    this.uploadUrl = `/api/tk/composedPaper/answerSheetLocate`;
                    break;
                case 'quick':
                    this.brainTitle = '速考试卷扫描';
                    this.uploadUrl = `/api/tk/composedPaper/answerSheetLocateQuick`;
                    break;
                case 'personal':
                    this.brainTitle = '个性化试卷扫描';
                    this.uploadUrl = `/api/tk/composedPaper/answerSheetLocateForQbot`;
                    break;
                default:
                    this.brainTitle = '';
            }
            Dynamsoft.WebTwainEnv.AutoLoad = false;
            Dynamsoft.WebTwainEnv.ProductKey ="f0068NQAAAL6ZH8fo96uB/PhyFGsEp7q5lfAitZLv5mMY6Bt7offwGsaI2BuGzsRPcsanR4Eq4/wvdbSciMGZF85P6Awq934=";
            Dynamsoft.WebTwainEnv.Trial = false;
            Dynamsoft.WebTwainEnv.ResourcesPath = 'https://schbrain-public.oss-cn-hangzhou.aliyuncs.com/contents/dwt';
                Dynamsoft.WebTwainEnv.Containers = [
                { ContainerId: "dwtcontrolContainer", Width: "270px", Height: "350px" }
            ];
            Dynamsoft.WebTwainEnv.RegisterEvent("OnWebTwainReady", () => {
                this.DWObject = Dynamsoft.WebTwainEnv.GetWebTwain("dwtcontrolContainer");
                this.onReady();
            });
        },
        mounted () {
            Dynamsoft.WebTwainEnv.Load();
            if (this.$route.query.start && this.$route.query.end) {
                this.forTollGetHistroy()
            }

            // if (this.$store.state.DWObject) {
            //     this.DWObject = this.$store.state.DWObject;
            //     this.onReady();
            // } else {
            //     setTimeout(() => {
            //         if (this.$store.state.DWObject) {
            //             this.DWObject = this.$store.state.DWObject;
            //             this.onReady();
            //         }
            //     }, 1000)
            // }
        },
        methods: {
            // 提交查看历史扫描时间
            submitRequestHistory () {
                if (!this.historyDateRange.length) {
                    this.$notify.error({
                        title: '提示',
                        message: '请选择日期！',
                        offset: 50,
                        duration: 3000
                    });
                    return
                }
                const startTime = new Date(this.historyDateRange[0]).Format('yyyy-MM-dd hh:mm:ss');
                const endTime = new Date(this.historyDateRange[1]).Format('yyyy-MM-dd hh:mm:ss');
                this.historyDateRangeText = `${startTime} - ${endTime}`;
                this.historyPopoverVisible = false;
                this.requestHistoryList()
            },
            // 清除历史记录
            clearHistoryRange () {
                this.historyDateRangeText = '';
                this.scanShowList = [];
                this.scanOriginList = [];
                this.scanBatch = 0;
                this.$nextTick(() => {
                    this.countNum(this.scanShowList)
                })
            },
            // 用于速考校验工具的获取历史记录
            forTollGetHistroy () {
                let start = this.$route.query.start;
                let end = this.$route.query.end;
                let startTime = new Date(Number(start)).Format('yyyy-MM-dd hh:mm:ss');
                let endTime = new Date(Number(end)).Format('yyyy-MM-dd hh:mm:ss');
                this.historyDateRangeText = `${startTime} - ${endTime}`;
                this.$https.get(`/api/tk/numberCheck/listScanHistory`, {
                    params:{
                        start: start,
                        end: end,
                        paperCode: '',
                        type: 0,
                        id: this.$route.query.id
                    }
                }).then((response)=>{
                    if (response.code === 0) {
                        this.scanShowList = [];
                        if (response.data && Array.isArray(response.data) && response.data.length) {
                            let data = JSON.parse(JSON.stringify(response.data));
                            let obj = {
                                list: [],
                                time: this.historyDateRangeText
                            };
                            let startTime = null;
                            let pageIndex = 0;
                            data.forEach((paper, key) => {
                                let result = paper.scanResultJo;
                                paper.isHistory = true;
                                // paper.pageIndex = key;
                                paper[1] = {
                                    pageNum: key + 1,
                                    frameNum: 1,
                                    url: paper.page1
                                };
                                paper[2] = {
                                    pageNum: key + 1,
                                    frameNum: 2,
                                    url: paper.page2
                                };
                                if (key + 1 < 10) {
                                    paper.pageNum = `0${key + 1}`
                                } else {
                                    paper.pageNum = String(key + 1)
                                }
                                if (result.success) {
                                    paper.status = 2;
                                    paper.isBlue = false
                                } else {
                                    paper.isBlue = false;
                                    paper.status = 3;
                                    paper.isUploadErr = false;
                                    paper.key = result.key;
                                    paper.message = result.message || '学生学号或姓名重复';
                                    paper.failCode = result.failCode;
                                    paper.paperCode = result.paperCode;
                                    paper.name = result.name;
                                    paper.needConfirmStudentCode = result.needConfirmStudentCode;
                                    paper.needConfirmPaperSize = result.needConfirmPaperSize;
                                    paper.needConfirmPaperCode = result.needConfirmPaperCode;
                                }
                                if (key === 0) {
                                    startTime = paper.createTime;
                                    obj.time = new Date(startTime).Format('yyyy-MM-dd hh:mm:ss');
                                    obj.list = [];
                                    pageIndex = 0
                                }
                                if (paper.createTime >= startTime - 30000) {
                                    if (key === 0) {
                                        pageIndex = 0;
                                    } else {
                                        pageIndex++;
                                    }
                                    paper.pageIndex = pageIndex;
                                    paper.batchIndex = this.scanShowList.length;
                                    obj.list.push(paper);
                                } else {
                                    if (obj.list.length) {
                                        this.scanShowList.push(JSON.parse(JSON.stringify(obj)));
                                    }
                                    paper.batchIndex = this.scanShowList.length;
                                    obj = {};
                                    startTime = paper.createTime;
                                    obj.time = new Date(startTime).Format('yyyy-MM-dd hh:mm:ss');
                                    obj.list = [];
                                    pageIndex = 0;
                                    paper.pageIndex = pageIndex;
                                    obj.list.push(paper);
                                }
                            });
                            if (obj.list.length) {
                                this.scanShowList.push(JSON.parse(JSON.stringify(obj)));
                            }
                        }
                        this.$nextTick(() => {
                            this.countNum(this.scanShowList)
                        })
                    } else {
                        this.$notify.error({
                            title: '错误',
                            message: response.message,
                            offset: 50,
                            duration: 3000
                        });
                    }
                    this.isLoading = false;
                },(error) => {
                    this.isLoading = false;
                    this.$notify.error({
                        title: '错误',
                        message: error.message || error.data.message,
                        offset: 50,
                        duration: 3000
                    });
                }).catch(errors => {
                    this.isLoading = false;
                    this.$errorLog(errors)
                });
            },
            // 获取历史记录
            requestHistoryList () {
                this.isLoading = true;
                let start = new Date(this.historyDateRange[0]).getTime();
                let end = new Date(this.historyDateRange[1]).getTime();
                let type;
                if ('quick'.includes(this.$route.query.type)) {
                    type = 2;
                } else if ('personal'.includes(this.$route.query.type)) {
                    type = 3;
                } else {
                    type = 1;
                }
                this.$https.post(`/api/tk/composedPaper/listScanHistory`, {
                    start: start,
                    end: end,
                    paperCode: this.historySearchValue,
                    type: type
                }).then((response)=>{
                    if (response.code === 0) {
                        this.scanShowList = [];
                        if (response.data && Array.isArray(response.data) && response.data.length) {
                            let data = JSON.parse(JSON.stringify(response.data));
                            let obj = {
                                list: [],
                                time: this.historyDateRangeText
                            };
                            let startTime = null;
                            let pageIndex = 0;
                            data.forEach((paper, key) => {
                                let result = paper.scanResultJo;
                                paper.isHistory = true;
                                // paper.pageIndex = key;
                                paper[1] = {
                                    pageNum: key + 1,
                                    frameNum: 1,
                                    url: paper.page1
                                };
                                paper[2] = {
                                    pageNum: key + 1,
                                    frameNum: 2,
                                    url: paper.page2
                                };
                                if (key + 1 < 10) {
                                    paper.pageNum = `0${key + 1}`
                                } else {
                                    paper.pageNum = String(key + 1)
                                }
                                if (result.success) {
                                    paper.status = 2;
                                    paper.isBlue = false
                                } else {
                                    paper.isBlue = false;
                                    paper.status = 3;
                                    paper.isUploadErr = false;
                                    paper.key = result.key;
                                    paper.message = result.message || '学生学号或姓名重复';
                                    paper.failCode = result.failCode;
                                    paper.paperCode = result.paperCode;
                                    paper.name = result.name;
                                    paper.needConfirmStudentCode = result.needConfirmStudentCode;
                                    paper.needConfirmPaperSize = result.needConfirmPaperSize;
                                    paper.needConfirmPaperCode = result.needConfirmPaperCode;
                                }
                                if (key === 0) {
                                    startTime = paper.createTime;
                                    obj.time = new Date(startTime).Format('yyyy-MM-dd hh:mm:ss');
                                    obj.list = [];
                                    pageIndex = 0
                                }
                                if (paper.createTime >= startTime - 30000) {
                                    if (key === 0) {
                                        pageIndex = 0;
                                    } else {
                                        pageIndex++;
                                    }
                                    paper.pageIndex = pageIndex;
                                    paper.batchIndex = this.scanShowList.length;
                                    obj.list.push(paper);
                                } else {
                                    if (obj.list.length) {
                                        this.scanShowList.push(JSON.parse(JSON.stringify(obj)));
                                    }
                                    paper.batchIndex = this.scanShowList.length;
                                    obj = {};
                                    startTime = paper.createTime;
                                    obj.time = new Date(startTime).Format('yyyy-MM-dd hh:mm:ss');
                                    obj.list = [];
                                    pageIndex = 0;
                                    paper.pageIndex = pageIndex;
                                    obj.list.push(paper);
                                }
                            });
                            if (obj.list.length) {
                                this.scanShowList.push(JSON.parse(JSON.stringify(obj)));
                            }
                            // console.log(this.scanShowList)
                            // obj.list = data;
                            // this.scanShowList.push(obj);
                        }
                        this.$nextTick(() => {
                            this.countNum(this.scanShowList)
                        })
                    } else {
                        this.$notify.error({
                            title: '错误',
                            message: response.message,
                            offset: 50,
                            duration: 3000
                        });
                    }
                    this.isLoading = false;
                },(error) => {
                    this.isLoading = false;
                    this.$notify.error({
                        title: '错误',
                        message: error.message || error.data.message,
                        offset: 50,
                        duration: 3000
                    });
                }).catch(errors => {
                    this.isLoading = false;
                    this.$errorLog(errors)
                });
            },
            // 获取上传状态
            getUploadStatus () {
                const list = JSON.parse(JSON.stringify(this.scanShowList));
                let uploadList = Array.from(list, item => item.list);
                uploadList = uploadList.flat();
                uploadList = uploadList.filter(item => item && item.hasOwnProperty('status') && item.status === 0);
                const ids = Array.from(uploadList, item => item.id);
                if (!ids.length) {
                    clearInterval(this.statusInterval);
                    this.statusInterval = null;
                    if (this.scanShowList && this.scanShowList.length > 0) {
                        this.scanShowList.forEach(item => {
                            if (item && item.list.length > 0) {
                                let currentCode = '';
                                item.list.forEach(paper => {
                                    if (paper.studentCode) {
                                        //当前学号后六位
                                        let sign = paper.studentCode.substring(0, 6);
                                        if (sign === currentCode) {
                                            paper.isBlue = this.isBlue
                                            // this.$set(paper ,'isBlue' ,this.isBlue)
                                        } else {
                                            this.isBlue = !this.isBlue;
                                            paper.isBlue = this.isBlue
                                            // this.$set(paper ,'isBlue' ,this.isBlue)
                                        }
                                        currentCode = paper.studentCode.substring(0, 6)
                                    }
                                })
                            }
                        })
                    }
                    return;
                }
                this.$https.post(`/api/tk/composedPaper/getLocateResult`, ids).then((response)=>{
                    if (response.code === 0) {
                        const object = response.data;
                        const list = Object.keys(object);
                        this.scanShowList.forEach((item) => {
                            item.list.forEach((paper) => {
                                if (!paper || !paper.id) {
                                    console.log(JSON.stringify(paper));
                                }
                                if (paper && paper.id && list.includes(paper.id) && object[paper.id]) {
                                    const result = object[paper.id];
                                    // let data = JSON.parse(JSON.stringify(this.scanShowList[paper.batchIndex]));
                                    if (result.success) {
                                        paper.status = 2;
                                        paper.studentCode = result.studentCode;
                                        paper.isBlue = true;
                                        paper.key = result.key;
                                        // data.list[paper.pageIndex].status = 2;
                                    } else {
                                        paper.status = 3;
                                        paper.isUploadErr = false;
                                        paper.key = result.key;
                                        paper.message = result.message || '学生学号或姓名重复';
                                        paper.failCode = result.failCode;
                                        paper.isBlue = true;
                                        paper.name = result.name;
                                        paper.studentCode = result.studentCode || '';
                                        paper.paperCode = result.paperCode;
                                        paper.needConfirmStudentCode = result.needConfirmStudentCode;
                                        paper.needConfirmPaperSize = result.needConfirmPaperSize;
                                        paper.needConfirmPaperCode = result.needConfirmPaperCode;
                                        paper.duplicateArray = result.duplicateArray || [];
                                        if (paper.duplicateArray.length) {
                                            this.scanShowList[paper.batchIndex].list.forEach(value => {
                                                if (value && value.id && paper.duplicateArray.includes(value.id)) {
                                                    value.status = 3;
                                                    value.failCode = 1;
                                                    value.message = value.message || '学生学号或姓名重复';
                                                    value.needConfirmStudentCode = true;
                                                    value.isSubmitCode = false;
                                                }
                                            })
                                        }
                                    }
                                    // this.$set(this.scanShowList, paper.batchIndex, data);
                                    this.$nextTick(() => {
                                        this.countNum(this.scanShowList)
                                    })
                                }
                            })
                        })
                    }
                },() => {
                }).catch(errors => {
                    this.$errorLog(errors)
                })
            },
            // 显示时间线
            showTimeLine (key, batch) {
                if (this.historyDateRangeText) {
                    return true
                }
                if (key === 0){
                    return false
                } else if (key === this.scanShowList.length - 1) {
                    return true
                }else {
                    if (batch.list.length) {
                        let status = false;
                        batch.list.forEach(i => {
                            if (i.status !== 2) {
                                status = true;
                            }
                        });
                        return status
                    } else {
                        return false
                    }
                }
            },
             // 计算上传率
            countNum (data) {
                let total = 0;
                let success = 0;
                let errors = 0;
                data.forEach(item => {
                    if (item && item.list) {
                        total += item.list && item.list.length;
                        let num = item.list.reduce((count, option) => {
                            if (option && option.hasOwnProperty('status') && option.status === 2) {
                                count++;
                            }
                            return count
                        },0);
                        let err = item.list.reduce((count, option) => {
                            if (option && option.hasOwnProperty('status') && option.status === 3) {
                                count++;
                            }
                            return count
                        },0);
                        errors += err;
                        success += num;
                    }
                });
                let rate = success / total * 100;
                this.scanNum = total;
                this.scanErrNum = errors;
                this.scanRate = Math.floor(rate);
            },
            // 扫描事件监听处理
            onReady () {
                let DWObject = this.DWObject;
                if (DWObject) {
                    DWObject.IfUseTwainDSM = true;
                    DWObject.RegisterEvent('OnPostTransferAsync', (outputInfo) => {
                        let imageIndex = DWObject.ImageIDToIndex(outputInfo.imageId);
                        let url = DWObject.GetImageURL(imageIndex);
                        let info = outputInfo.imageInfo.ImageLayout;
                        let pageInfo = {};
                        if (this.sourceName.includes('EPSON') && info && info.hasOwnProperty('PageNumber') && info.hasOwnProperty('FrameNumber')) {
                            pageInfo.PageNumber = info.PageNumber;
                            pageInfo.FrameNumber = info.FrameNumber;
                        } else {
                            let extendInfo = outputInfo.extendedImageInfo;
                            if (extendInfo && extendInfo.others && extendInfo.others.hasOwnProperty('TWEI_PAGESIDE') && extendInfo.others.hasOwnProperty('TWEI_PAPERCOUNT')) {
                                pageInfo.PageNumber = Number(extendInfo.others.TWEI_PAPERCOUNT) + 1;
                                pageInfo.FrameNumber = extendInfo.others.TWEI_PAGESIDE;
                                let num = Math.ceil(this.scanBatchNumberCount / 2);
                                // 柯达 TWEI_PAPERCOUNT 从0 计数   适配部分 从1计数
                                if (String(pageInfo.PageNumber) !== String(num) && String(pageInfo.PageNumber) === String(num + 1)) {
                                    pageInfo.PageNumber = num;
                                }
                            } else {
                                pageInfo.PageNumber = Math.ceil(this.scanBatchNumberCount / 2);
                                pageInfo.FrameNumber = imageIndex % 2 ? 2 : 1;
                            }
                        }
                        // DWObject.ConvertToBase64([DWObject.HowManyImagesInBuffer - 1], EnumDWT_ImageType.IT_JPG, (e) => {
                        //     console.log('data:image/png;base64,', e);
                        // }, function (e) {
                        //     console.log(e)
                        // });
                        // this.$https.get('https://k8s-log-c019b1204c5d6490d9c2a64d00c3f53ad.cn-hangzhou.log.aliyuncs.com/logstores/web-tracking/track?APIVersion=0.6.0&response=' + JSON.stringify(outputInfo) + '&origin=scanList&pageInfo=' + JSON.stringify(pageInfo) + '&url=' + url + '&imageIndex=' + imageIndex + '&scanBatchNumberCount=' + this.scanBatchNumberCount);
                        this.scanBatchNumberCount++;
                        // eslint-disable-next-line no-undef
                        DWObject.ConvertToBlob([imageIndex], EnumDWT_ImageType.IT_JPG, (e) => {
                            if (this.scanOriginList[this.scanBatch - 1] && this.scanOriginList[this.scanBatch - 1].list[pageInfo.PageNumber - 1]) {
                                let obj = {
                                    imageIndex: imageIndex,
                                    pageNum: pageInfo.PageNumber,
                                    frameNum: pageInfo.FrameNumber,
                                    pageInfo: pageInfo,
                                    url: url,
                                    blob: e
                                };
                                this.scanNum++; // 扫描份数
                                let num = Math.ceil((imageIndex + 1) / 2);
                                this.scanOriginList[this.scanBatch - 1].list[pageInfo.PageNumber - 1][pageInfo.FrameNumber] = obj;
                                this.scanOriginList[this.scanBatch - 1].list[pageInfo.PageNumber - 1].pageNum = num > 9 ? num : '0' + num;
                                this.scanOriginList[this.scanBatch - 1].list[pageInfo.PageNumber - 1].status = -1;
                                this.scanOriginList[this.scanBatch - 1].list[pageInfo.PageNumber - 1].batchIndex = this.scanBatch - 1;
                                this.scanOriginList[this.scanBatch - 1].list[pageInfo.PageNumber - 1].pageIndex = pageInfo.PageNumber - 1;
                                this.scanOriginList[this.scanBatch - 1].list[pageInfo.PageNumber - 1].imageId = outputInfo.imageId;
                                if (this.scanShowList[this.scanBatch - 1] && this.scanShowList[this.scanBatch - 1].list) {
                                    this.scanShowList[this.scanBatch - 1].list[pageInfo.PageNumber - 1] = this.scanOriginList[this.scanBatch - 1].list[pageInfo.PageNumber - 1];
                                } else {
                                    this.scanShowList[this.scanBatch - 1] = {
                                        time: '',
                                        date: '',
                                        list: []
                                    };
                                    this.scanShowList[this.scanBatch - 1].time = this.scanOriginList[this.scanBatch - 1].time;
                                    this.scanShowList[this.scanBatch - 1].date = this.scanOriginList[this.scanBatch - 1].date;
                                    this.scanShowList[this.scanBatch - 1].list[pageInfo.PageNumber - 1] = this.scanOriginList[this.scanBatch - 1].list[pageInfo.PageNumber - 1];
                                }
                                let data = this.scanShowList[this.scanBatch - 1].list[pageInfo.PageNumber - 1];
                                this.uploadPaper(data);
                            } else {
                                let obj = {
                                    imageIndex: imageIndex,
                                    pageNum: pageInfo.PageNumber,
                                    frameNum: pageInfo.FrameNumber,
                                    pageInfo: pageInfo,
                                    url: url,
                                    blob: e
                                };
                                let result = {};
                                result[pageInfo.FrameNumber] = obj;
                                this.scanOriginList[this.scanBatch - 1].list[pageInfo.PageNumber - 1] = result;
                            }
                            // this.$https.get('https://k8s-log-c019b1204c5d6490d9c2a64d00c3f53ad.cn-hangzhou.log.aliyuncs.com/logstores/web-tracking/track?APIVersion=0.6.0&response=' + JSON.stringify(this.scanOriginList) + '&origin=scanList&url=' + url + '&imageIndex=' + imageIndex + '&scanBatch=' + this.scanBatch + '&pageInfo.PageNumber=' + JSON.stringify(pageInfo));
                        }, () => {
                            this.$notify.error({
                                title: '错误',
                                message: '获取文件失败！',
                                offset: 50,
                                duration: 3000
                            });
                        });
                    });
                    DWObject.RegisterEvent('OnPostAllTransfers',() => {
                        // this.scanNum = DWObject.HowManyImagesInBuffer;
                        // console.log(this.scanOriginList);
                        // console.log(this.scanShowList);
                        let type;
                        if ('quick'.includes(this.$route.query.type)) {
                            type = 2;
                        } else if ('personal'.includes(this.$route.query.type)) {
                            type = 3;
                        } else {
                            type = 1;
                        }
                        this.$https.get(`/api/tk/composedPaper/locateFinished`, {
                            params: {
                                type: type,
                                timestamp: this.scanOriginList[this.scanBatch - 1].date
                            }
                        }).then(()=>{
                        }).catch(errors => {
                            this.$errorLog(errors)
                        })
                    });
                }
            },
            // 上传试卷
            uploadPaper (item) {
                // status -1 等待  0 上传中 2 成功 3 失败
                const formData = new FormData();
                formData.append('file1', item[1].blob);
                formData.append('file2', item[2].blob);
                formData.append('timestamp', this.scanShowList[item.batchIndex].date);
                // const uploadUrl = this.$route.query.isNormal ? `/api/tk/composedPaper/answerSheetLocate` : `/api/tk/composedPaper/answerSheetLocateForQbot`;
                this.$https.post(this.uploadUrl, formData).then((response)=>{
                    if (response.code === 0) {
                        let data = JSON.parse(JSON.stringify(this.scanShowList[item.batchIndex]));
                        data.list[item.pageIndex].id = response.data;
                        data.list[item.pageIndex].status = 0;
                        data.list[item.pageIndex].isBlue = false;
                        this.$set(this.scanShowList, item.batchIndex, data);
                        this.$nextTick(() => {
                            this.countNum(this.scanShowList)
                        });
                        if (!this.statusInterval) {
                            this.statusInterval = setInterval(() => {
                                this.getUploadStatus();
                            }, 3000)
                        }
                    } else {
                        let data = JSON.parse(JSON.stringify(this.scanShowList[item.batchIndex]));
                        data.list[item.pageIndex].status = 3;
                        data.list[item.pageIndex].isUploadErr = true;
                        data.list[item.pageIndex].uploadErrMessage = response.message;
                        this.$set(this.scanShowList, item.batchIndex, data);
                        this.$nextTick(() => {
                            this.countNum(this.scanShowList)
                        })
                    }
                },(error) => {
                    let data = JSON.parse(JSON.stringify(this.scanShowList[item.batchIndex]));
                    data.list[item.pageIndex].status = 3;
                    data.list[item.pageIndex].isUploadErr = true;
                    data.list[item.pageIndex].uploadErrMessage = error.message || error.data.message;
                    this.$set(this.scanShowList, item.batchIndex, data);
                    this.$nextTick(() => {
                        this.countNum(this.scanShowList)
                    })
                }).catch(errors => {
                    let data = JSON.parse(JSON.stringify(this.scanShowList[item.batchIndex]));
                    data.list[item.pageIndex].status = 3;
                    data.list[item.pageIndex].isUploadErr = true;
                    data.list[item.pageIndex].uploadErrMessage = errors.message || errors.data.message;
                    this.$set(this.scanShowList, item.batchIndex, data);
                    this.$nextTick(() => {
                        this.countNum(this.scanShowList)
                    });
                    this.$errorLog(errors)
                })
            },
            // 异常试卷开关
            switchChange () {
                // eslint-disable-next-line no-console
                // console.log(data, this.switchValue)
            },
            // 页码确认选择页码
            selectPage (item) {
                if (item.select) return;
                this.pageList.forEach(i => {
                    i.forEach(j => {j.select = false})
                });
                item.select = true;
            },
            // x4 x8 试卷展示方式
            changeStyle (item) {
                if (item.select) return;
                this.styleList.forEach(i => {i.select = false});
                item.select = true;
            },
            // 删除异常试卷任务
            deleteScanPaper (paper) {
                let data;
                this.scanShowList[paper.batchIndex].list.every(item => {
                    if (String(item.imageId) === String(paper.imageId)) {
                        data = item;
                        return false
                    }
                    return true
                });
                this.scanShowList[paper.batchIndex].list.remove(data);
                this.countNum(this.scanShowList);
            },
            // 删除  - 任务 - 显示提示
            showEmpty (list) {
                if (!list.length) return true;
                let data = list.reduce((total, item) => {
                    if (item.list.length) {
                        total++;
                    }
                    return total
                },0);
                return !data;
            },
            // 任务显示判断
            isShowScan (key, single) {
                if (single && single.hasOwnProperty('status')) {
                    if (this.switchValue) {
                        return single.status === 3;
                    } else {
                        if (single && single.hasOwnProperty('status') && single.status === 2) {
                            // 历史记录显示上传成功
                            return this.historyDateRangeText || key === this.scanShowList.length - 1;
                        }
                        return true;
                    }
                } else {
                    return false;
                }
            },
            // 选择其他试卷
            changePaperName () {
                this.pageList = [];
                let activeIndex = 0;
                this.paperNameList.every((value, index) => {
                    if (String(value.paperCode) === String(this.paperName)) {
                        activeIndex = index;
                        return false
                    }
                    return true
                });
                if (this.paperNameList[activeIndex].paperSize) {
                    this.initPageSize(Math.ceil(Number(this.paperNameList[activeIndex].paperSize) / 2));
                } else {
                    this.$notify.error({
                        title: '错误',
                        message: '未获取到试卷页码',
                        offset: 50,
                        duration: 3000
                    });
                }
            },
            // 确认试卷页码
            showPaperDialog (data) {
                if (data.isHistory) {
                    this.historyShowPaperDialog(data);
                    return
                }
                let url = '/api/tk/composedPaper/recentScanComposedPaperInfo';
                if (this.$route.query.type && this.$route.query.type === 'quick') {
                    url = `/api/tk/composedPaper/recentScanComposedPaperInfoForQuick`
                }
                this.$https.get(url, {
                    params: {
                        timestamp: this.scanShowList[data.batchIndex].date
                    }
                }).then((response)=>{
                    if (response.code === 0) {
                        // this.paperName = response.data.name;
                        this.pageList = [];
                        if (response.data && Array.isArray(response.data) && response.data.length) {
                            this.paperNameList = response.data.map((item) => {
                                item.value = item.paperCode;
                                // item.name = item.paperName;
                                return item;
                            });
                            if (this.paperNameList.length === 1) {
                                this.paperName = this.paperNameList[0].value;
                            } else {
                                this.paperName = ''
                            }
                            if (this.paperNameList[0].paperSize) {
                                this.currentPaper = data;
                                let activeIndex = 0;
                                if (data.paperCode) {
                                    this.paperNameList.every((value, index) => {
                                        if (String(value.paperCode) === String(data.paperCode)) {
                                            this.paperName = value.paperCode;
                                            activeIndex = index;
                                            return false
                                        }
                                        return true
                                    })
                                }
                                if (this.paperName) {
                                    this.initPageSize(Math.ceil(Number(this.paperNameList[activeIndex].paperSize) / 2));
                                } else {
                                    this.paperDialogVisible = true;
                                }
                            } else {
                                this.$notify.error({
                                    title: '错误',
                                    message: '未获取到试卷页码',
                                    offset: 50,
                                    duration: 3000
                                });
                            }
                        } else {
                            this.$notify.error({
                                title: '错误',
                                message: '未获取到试卷页码',
                                offset: 50,
                                duration: 3000
                            });
                        }
                        // if (response.data.paperSize) {
                        //     this.currentPaper = data;
                        //     this.initPageSize(Math.ceil(Number(response.data.paperSize) / 2));
                        // } else {
                        //     this.$notify.error({
                        //         title: '错误',
                        //         message: '未获取到试卷页码',
                        //         offset: 50,
                        //         duration: 3000
                        //     });
                        // }
                    } else {
                        this.$notify.error({
                            title: '错误',
                            message: response.message,
                            offset: 50,
                            duration: 3000
                        });
                    }
                },(error) => {
                    this.$notify.error({
                        title: '错误',
                        message: error.message || error.data.message,
                        offset: 50,
                        duration: 3000
                    });
                }).catch(errors => {
                    this.$errorLog(errors)
                });
            },
            // history 显示确认试卷弹窗
            historyShowPaperDialog (data) {
                const start = new Date(this.historyDateRange[0]).getTime();
                const end = new Date(this.historyDateRange[1]).getTime();
                let type;
                if ('quick'.includes(this.$route.query.type)) {
                    type = 2;
                } else if ('personal'.includes(this.$route.query.type)) {
                    type = 3;
                } else {
                    type = 1;
                }
                this.$https.post(`/api/tk/composedPaper/getScanPaperInfoSpeTime`, {
                    start: start,
                    end: end,
                    type: type
                }).then((response)=>{
                    if (response.code === 0) {
                        // this.paperName = response.data.name;
                        this.pageList = [];
                        if (response.data && Array.isArray(response.data) && response.data.length) {
                            this.paperNameList = response.data.map((item) => {
                                item.value = item.paperCode;
                                // item.name = item.paperName;
                                return item;
                            });
                            if (this.paperNameList.length === 1) {
                                this.paperName = this.paperNameList[0].value;
                            } else {
                                this.paperName = ''
                            }
                            if (this.paperNameList[0].paperSize) {
                                this.currentPaper = data;
                                let activeIndex = 0;
                                if (data.paperCode) {
                                    this.paperNameList.every((value, index) => {
                                        if (String(value.paperCode) === String(data.paperCode)) {
                                            this.paperName = value.paperCode;
                                            activeIndex = index;
                                            return false
                                        }
                                        return true
                                    })
                                }
                                if (this.paperName) {
                                    this.initPageSize(Math.ceil(Number(this.paperNameList[activeIndex].paperSize) / 2));
                                } else {
                                    this.paperDialogVisible = true;
                                }
                            } else {
                                this.$notify.error({
                                    title: '错误',
                                    message: '未获取到试卷页码',
                                    offset: 50,
                                    duration: 3000
                                });
                            }
                        } else {
                            this.$notify.error({
                                title: '错误',
                                message: '未获取到试卷页码',
                                offset: 50,
                                duration: 3000
                            });
                        }
                    } else {
                        this.$notify.error({
                            title: '错误',
                            message: response.message,
                            offset: 50,
                            duration: 3000
                        });
                    }
                },(error) => {
                    this.$notify.error({
                        title: '错误',
                        message: error.message || error.data.message,
                        offset: 50,
                        duration: 3000
                    });
                }).catch(errors => {
                    this.$errorLog(errors)
                });
            },
            // 显示学号弹窗
            showCodeDialog (data) {
                this.studentCodeValue = '';
                this.currentPaper = data;
                if (data.id || data.studentCode) {
                    this.studentCodeValue = data.studentCode;
                }
                this.codeDialogVisible = true;
            },
            // 显示学号弹窗
            showPaperCodeDialog (data) {
                this.paperCodeValue = '';
                this.currentPaper = data;
                this.paperCodeDialogVisible = true;
            },
            // 初始化试卷页码
            initPageSize (size) {
                let topArr = [];
                let bottomArr = [];
                for (let i =0;i< size; i++) {
                    let right = (i + 1) * 2;
                    let left = right - 1;
                    topArr.push({
                        name: left + '-' + right,
                        select: false
                    });
                    bottomArr.push({
                        name: right + '-' + left,
                        select: false
                    })
                }
                this.pageList.push(topArr);
                this.pageList.push(bottomArr);
                this.paperDialogVisible = true;
            },
            // 提交学号
            submitCode (data, force) {
                if (!this.studentCodeValue.replace(/\s/g,'')) {
                    this.$notify.error({
                        title: '提示',
                        message: '请输入学号！',
                        offset: 50,
                        duration: 3000
                    });
                    return
                }
                if (!data) {
                    this.$notify.error({
                        title: '提示',
                        message: '试卷信息不存在！',
                        offset: 50,
                        duration: 3000
                    });
                    return
                }
                if (data.isHistory) {
                    if (!data.id) {
                        this.$notify.error({
                            title: '提示',
                            message: '试卷不存在id！',
                            offset: 50,
                            duration: 3000
                        });
                        return
                    }
                    this.submitHistoryPaperCode(data, 'studentCode', this.studentCodeValue);
                    return;
                }
                if (!data.key) {
                    this.$notify.error({
                        title: '提示',
                        message: '试卷不存在key！',
                        offset: 50,
                        duration: 3000
                    });
                    return;
                }
                const isQuickUrl = this.$route.query.type === 'quick' ? `/api/tk/composedPaper/setAnswerSheetPaperInfoQuick`: `/api/tk/composedPaper/setAnswerSheetPaperInfo`;
                this.$https.post(isQuickUrl, {
                    key: data.key,
                    force: force,
                    studentCode: this.studentCodeValue
                }).then((response)=>{
                    if (response.code === 0) {
                        this.codeDialogVisible = false;
                        let obj = JSON.parse(JSON.stringify(this.scanShowList[data.batchIndex]));
                        obj.list[data.pageIndex].isSubmitCode = true;
                        if ('quick/normal'.includes(this.scanPaperType)) {
                            if ((!data.needConfirmPaperSize && !data.needConfirmPaperCode) || data.isSubmitPaper) {
                                obj.list[data.pageIndex].status = 2;
                                obj.list[data.pageIndex].studentCode = response.data;
                            } else {
                                obj.list[data.pageIndex].studentCode = response.data;
                            }
                        } else {
                            if (data.failCode === 1 || (data.failCode === 0 && data.isSubmitPaper)) {
                                obj.list[data.pageIndex].status = 2;
                                obj.list[data.pageIndex].studentCode = response.data;
                            } else {
                                obj.list[data.pageIndex].studentCode = response.data;
                            }
                        }
                        this.$set(this.scanShowList, data.batchIndex, obj);
                        this.$nextTick(() => {
                            this.countNum(this.scanShowList)
                        })
                    }
                },(error) => {
                    if (error.code === 501) {
                        this.$confirm(error.message, '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.submitCode(data, true)
                        }).catch(() => {
                        });
                    } else {
                        this.$notify.error({
                            title: '错误',
                            message: error.message || error.data.message,
                            offset: 50,
                            duration: 3000
                        });
                    }
                }).catch(errors => {
                    this.$errorLog(errors)
                });
            },
            // 提交试卷编号
            submitPaperCode (data) {
                if (!this.paperCodeValue.replace(/\s/g,'')) {
                    this.$notify.error({
                        title: '提示',
                        message: '请输入作业编号！',
                        offset: 50,
                        duration: 3000
                    });
                    return
                }
                if (!data) {
                    this.$notify.error({
                        title: '提示',
                        message: '试卷信息不存在不存在！',
                        offset: 50,
                        duration: 3000
                    });
                    return
                }
                if (data.isHistory) {
                    if (!data.id) {
                        this.$notify.error({
                            title: '提示',
                            message: '试卷不存在id！',
                            offset: 50,
                            duration: 3000
                        });
                        return
                    }
                    this.submitHistoryPaperCode(data, 'paperCode', this.paperCodeValue);
                    return;
                }
                if (!data.key) {
                    this.$notify.error({
                        title: '提示',
                        message: '试卷不存在key！',
                        offset: 50,
                        duration: 3000
                    });
                    return
                }
                this.$https.post(`/api/tk/composedPaper/setAnswerSheetPaperInfoForQbot`, {
                    key: data.key,
                    paperCode: this.paperCodeValue
                }).then((response)=>{
                    if (response.code === 0) {
                        this.paperCodeDialogVisible = false;
                        let obj = JSON.parse(JSON.stringify(this.scanShowList[data.batchIndex]));
                        obj.list[data.pageIndex].isSubmitCode = true;
                        obj.list[data.pageIndex].status = 2;
                        this.$set(this.scanShowList, data.batchIndex, obj);
                        this.$nextTick(() => {
                            this.countNum(this.scanShowList)
                        })
                    } else {
                        this.$notify.error({
                            title: '错误',
                            message: response.message,
                            offset: 50,
                            duration: 3000
                        });
                    }
                },(error) => {
                    this.$notify.error({
                        title: '错误',
                        message: error.message || error.data.message,
                        offset: 50,
                        duration: 3000
                    });
                }).catch(errors => {
                    this.$errorLog(errors)
                });
            },
            // 历史试卷提交试卷信息 试卷 类型 内容
            submitHistoryPaperCode (data, model,value, force) {
                const start = new Date(this.historyDateRange[0]).getTime();
                const end = new Date(this.historyDateRange[1]).getTime();
                let type;
                if ('quick'.includes(this.$route.query.type)) {
                    type = 2;
                } else if ('personal'.includes(this.$route.query.type)) {
                    type = 3;
                } else {
                    type = 1;
                }
                let sendData = {
                    id: data.id,
                    start: start,
                    end: end,
                    type: type
                };
                if (model === 'size') {
                    sendData.paperSize = value;
                    let paperIndex = 0;
                    this.paperNameList.every((paperInfo, paperInfoIndex) => {
                        if (String(this.paperName) === String(paperInfo.paperCode)) {
                            paperIndex = paperInfoIndex;
                            return false;
                        }
                        return true;
                    });
                    sendData.paperCode = this.paperNameList[paperIndex].paperCode || null;
                    sendData.version  = this.paperNameList[paperIndex].version  || null;
                } else if (model === 'studentCode') {
                    sendData.studentCode = value;
                    sendData.force = force || false;
                } else if (model === 'paperCode') {
                    sendData.qbotPaperCode = value;
                }
                this.$https.post(`/api/tk/composedPaper/setAnswerSheetPaperInfoSpeTime`, sendData).then((response)=>{
                    if (response.code === 0) {
                        let obj = JSON.parse(JSON.stringify(this.scanShowList[data.batchIndex]));
                        if (model === 'size') {
                            this.paperDialogVisible = false;
                            obj.list[data.pageIndex].isSubmitPaper = true;
                            if (data.isSubmitCode) {
                                obj.list[data.pageIndex].status = 2;
                                obj.list[data.pageIndex].studentCode = response.data;
                            }
                        } else if (model === 'studentCode') {
                            this.codeDialogVisible = false;
                            obj.list[data.pageIndex].isSubmitCode = true;
                            // console.log(data)
                            if ('quick/normal'.includes(this.scanPaperType)) {
                                if ((!data.needConfirmPaperSize && !data.needConfirmPaperCode) || data.isSubmitPaper) {
                                    obj.list[data.pageIndex].status = 2;
                                    obj.list[data.pageIndex].studentCode = response.data;
                                } else {
                                    obj.list[data.pageIndex].studentCode = response.data;
                                }
                            } else {
                                if (data.failCode === 1 || (data.failCode === 0 && data.isSubmitPaper)) {
                                    obj.list[data.pageIndex].status = 2;
                                    obj.list[data.pageIndex].studentCode = response.data;
                                } else {
                                    obj.list[data.pageIndex].studentCode = response.data;
                                }
                            }
                        } else if (model === 'paperCode') {
                            this.paperCodeDialogVisible = false;
                            obj.list[data.pageIndex].isSubmitCode = true;
                            obj.list[data.pageIndex].status = 2;
                        }
                        this.$set(this.scanShowList, data.batchIndex, obj);
                        // this.$nextTick(() => {
                        //     this.countNum(this.scanShowList)
                        // })
                    } else {
                        this.$notify.error({
                            title: '错误',
                            message: response.message,
                            offset: 50,
                            duration: 3000
                        });
                    }
                },(error) => {
                    if (error.code === 501) {
                        this.$confirm(error.message, '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.submitHistoryPaperCode(data, model, value, true)
                        }).catch(() => {
                        });
                    } else {
                        this.$notify.error({
                            title: '错误',
                            message: error.message || error.data.message,
                            offset: 50,
                            duration: 3000
                        });
                    }
                }).catch(errors => {
                    this.$errorLog(errors)
                });
            },
            // 确认页数
            submitPaper (data) {
                if (!data) {
                    this.$notify.error({
                        title: '提示',
                        message: '试卷不存在!',
                        offset: 50,
                        duration: 3000
                    });
                    return
                }
                let size = '';
                this.pageList.forEach(i => {
                   i.forEach(j => {
                       if (j.select) {
                           size = j.name;
                       }
                   })
                });
                if (!size) {
                    this.$notify.error({
                        title: '提示',
                        message: '请选择页码',
                        offset: 50,
                        duration: 3000
                    });
                    return
                }
                if (data.isHistory) {
                    if (!data.id) {
                        this.$notify.error({
                            title: '提示',
                            message: '试卷不存在id！',
                            offset: 50,
                            duration: 3000
                        });
                        return
                    }
                    this.submitHistoryPaperCode(data, 'size',size);
                    return;
                }
                if (!data.key) {
                    this.$notify.error({
                        title: '提示',
                        message: '试卷不存在key！',
                        offset: 50,
                        duration: 3000
                    });
                    return
                }
                const newUrl = this.$route.query.type === 'quick' ? `/api/tk/composedPaper/setAnswerSheetPaperInfoQuick`: `/api/tk/composedPaper/setAnswerSheetPaperInfo`;
                let paperIndex = 0;
                this.paperNameList.every((paperInfo, paperInfoIndex) => {
                    if (String(this.paperName) === String(paperInfo.paperCode)) {
                        paperIndex = paperInfoIndex;
                        return false;
                    }
                    return true;
                });
                let sendData = {
                    key: data.key,
                    paperSize: size
                };
                sendData.paperCode = this.paperNameList[paperIndex].paperCode || null;
                sendData.version  = this.paperNameList[paperIndex].version  || null;
                this.$https.post(newUrl, sendData).then((response)=>{
                    if (response.code === 0) {
                        this.paperDialogVisible = false;
                        let obj = JSON.parse(JSON.stringify(this.scanShowList[data.batchIndex]));
                        obj.list[data.pageIndex].isSubmitPaper = true;
                        if (data.isSubmitCode) {
                            obj.list[data.pageIndex].status = 2;
                            obj.list[data.pageIndex].studentCode = response.data
                        }
                        this.$set(this.scanShowList, data.batchIndex, obj);
                        this.$nextTick(() => {
                            this.countNum(this.scanShowList)
                        })
                    } else {
                        this.$notify.error({
                            title: '错误',
                            message: response.message,
                            offset: 50,
                            duration: 3000
                        });
                    }
                },(error) => {
                    this.$notify.error({
                        title: '错误',
                        message: error.message || error.data.message,
                        offset: 50,
                        duration: 3000
                    });
                }).catch(errors => {
                    this.$errorLog(errors)
                });
            },
            // 保存试卷到本地
            saveLocal (index) {
                this.DWObject.IfShowFileDialog = true;
                this.DWObject.SaveAsJPEG("aa" + index, index);
            },
            // 开始扫描
            scanAgain () {
                let DWObject = this.DWObject;
                if (DWObject) {
                    DWObject.SelectSource(() => {
                        let OnAcquireImageSuccess,OnAcquireImageFailure;
                        OnAcquireImageSuccess = OnAcquireImageFailure = function () {
                            DWObject.CloseSource();
                        };
                        this.sourceName = DWObject.CurrentSourceName;
                        DWObject.OpenSource();
                        DWObject.Resolution = 300; // 设置扫描分辨率
                        DWObject.IfDisableSourceAfterAcquire = true; // 开始扫描关闭选择设备
                        DWObject.IfFeederEnabled = true; // 开启扫描仪试卷检查
                        if (DWObject.IfFeederEnabled === true) {
                            if (DWObject.IfFeederLoaded !== true && DWObject.ErrorCode === 0) {
                                this.setPaperDialogVisible = true;
                                return;
                            }
                        }
                        DWObject.SetLanguage(8); // 设置语言
                        DWObject.IfShowProgressBar = false;
                        DWObject.JPEGQuality = 80; // 图片质量
                        // eslint-disable-next-line no-undef
                        DWObject.TIFFCompressionType = EnumDWT_TIFFCompressionType.TIFF_JPEG; // 扫描类型
                        DWObject.IfDuplexEnabled = true;// Scan in Simplex mode (only 1 side of the page)
                        if (this.$route.query.type && 'quick/normal'.includes(this.$route.query.type)) {
                            // eslint-disable-next-line no-undef
                            DWObject.PixelType = EnumDWT_PixelType.TWPT_RGB; // Scan pages in RGB
                        } else {
                            // eslint-disable-next-line no-undef
                            DWObject.PixelType = EnumDWT_PixelType.TWPT_GRAY; // Scan pages in GRAY
                        }
                        DWObject.IfShowUI = false; // 是否显示驱动设置
                        this.scanBatch++; // 扫描批次
                        this.scanBatchNumberCount = 1; // 扫描批次 份数计数 一面
                        // if (this.scanBatch > 1) {
                        //     this.clearSuccessPaper(this.scanBatch - 1); // 清楚 已成功任务
                        // }
                        this.scanOriginList[this.scanBatch - 1] = {
                            time: new Date().Format('hh:mm'),
                            date: Date.now(),
                            list: []
                        };
                        // DWObject.IfShowIndicator = false;
                        DWObject.AcquireImage(OnAcquireImageSuccess, OnAcquireImageFailure);
                    }, () => {
                        this.$notify.error({
                            title: '提示',
                            message: '设备选择关闭或失败',
                            offset: 50,
                            duration: 3000
                        });
                    });
                }
            },
            // 再次扫描
            submitScanAgain () {
                this.setPaperDialogVisible = false;
                this.scanAgain()
            },
        },
        computed: {
            list: function () {
                let arr = [];
                if (this.scanShowList.length > 0) {
                    this.scanShowList.forEach(item => {
                        if (item.studentCode) {
                            item.list.forEach(item => {
                                arr.push(item.studentCode)
                            })
                        }
                    });
                    return arr
                } else {
                    return []
                }
            }
        },
        watch:{
            list: {
                handler() {
                    if (this.timer) {
                        clearTimeout(this.timer)
                    }
                    this.timer = setTimeout(() => {
                        if (this.scanShowList && this.scanShowList.length > 0) {
                            this.scanShowList.forEach(item => {
                                if (item && item.list.length > 0) {
                                    let currentCode = '';
                                    item.list.forEach(paper => {
                                        if (paper.studentCode) {
                                            //当前学号后六位;
                                            let sign = paper.studentCode.substring(0, 6);
                                            if (sign === currentCode) {
                                                paper.isBlue = this.isBlue
                                                // this.$set(paper ,'isBlue' ,this.isBlue)
                                            } else {
                                                this.isBlue = !this.isBlue;
                                                paper.isBlue = this.isBlue
                                                // this.$set(paper ,'isBlue' ,this.isBlue)
                                            }
                                            currentCode = paper.studentCode.substring(0, 6)
                                        }
                                    })
                                }
                            })
                        }
                    }, 500)
                },
                immediate: true
            },
            historySearchValue (newV) {
                this.historySearchValue = newV.replace(/[^\d]/g,'')
            },
        }
    }
</script>
<style lang="scss">
    .scan-history-popover-content{
        padding: 10px;
        .scan-history-title{
            font-size: 16px;
            font-weight: 500;
            color: #333333;
            margin-bottom: 15px;
        }
        .scan-history-date{
            width: 293px;
        }
        .scan-history-bar{
            display: flex;
            align-items: center;
            justify-content: flex-end;
            margin-top: 25px;
            .scan-history-input{
                margin-right: 21px;
                width:148px;
                height:30px;
                border-radius:4px;
                border:1px solid rgba(228,228,228,1);
                outline: none;
                box-sizing: border-box;
                padding: 0 9px;
                font-size:12px;
                font-weight:400;
                color: #333333;
                &::placeholder{
                    color:rgba(187,187,187,1);
                }
            }
            .scan-history-btn{
                width: 55px;
                height: 32px;
                line-height: 32px;
                background: #2996f3;
                border: 1px solid #2996f3;
                border-radius: 3px;
                font-size: 14px;
                font-weight: 500;
                color: #fff;
                text-align: center;
                padding: 0;
                cursor: pointer;
                &.btn-cancel{
                    color: #2996f3;
                    background: white;
                    margin-left: 14px;
                }
            }
        }
    }
</style>
<style lang="scss" scoped>
    .scan-list{
        height: 100%;
        .scan-list-container{
            height: calc(100% - 70px);
            overflow: auto;
            .ppp{
                width: 50px;
            }
            .scan-list-content{
                width: 1114px;
                min-height:calc(100% - 60px);
                background:rgba(255,255,255,1);
                border-radius:32px;
                margin: 30px auto;
                box-sizing: border-box;
                box-shadow: 0 0 17px 0 rgba(7, 0, 2, 0.05);
                .scan-list-head{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    .scan-list-head-history{
                        .show-history{
                            font-size:16px;
                            font-weight:500;
                            cursor: pointer;
                            color:rgba(41,150,243,1);
                            outline: none;
                        }
                        .show-history-time{
                            font-size:16px;
                            cursor: pointer;
                            font-weight:400;
                            outline: none;
                            color:rgba(51,51,51,1);
                            .el-icon-error{
                                color: #D8D8D8;
                                margin-left: 3px;
                            }
                        }
                    }
                }
                .scan-list-body{
                    margin-top: 30px;
                    .scan-batch{
                        .scan-batch-title{
                            position: relative;
                            margin: 20px 0 30px 0;
                            text-align: left;
                            .can-batch-title-block{
                                height:18px;
                                background:rgba(238,238,238,1);
                                border-radius:5px;
                                padding: 0 11px;
                                display: inline-block;
                                font-size: 12px;
                                color: #8B8B8B;
                            }
                            .can-batch-title-dash{
                                display: inline-block;
                                width: calc(100% - 120px);
                                height: 1px;
                                position: absolute;
                                top: 8px;
                                right: 0;
                                border-top: 1px dashed #D9D9D9;
                            }
                        }
                    }
                    .empty-content{
                        padding-top: 50px;
                        .empty-img{
                            width: 250px
                        }
                        .empty-text:after{
                            content: '';
                            width: 75px;
                            position: absolute;
                            height: 2px;
                            background: #DFDFDF;
                            color: #DFDFDF;
                            top: 11px;
                            right: 0;
                        }
                        .empty-text:before{
                            content: '';
                            width: 75px;
                            position: absolute;
                            height: 2px;
                            background: #DFDFDF;
                            color: #DFDFDF;
                            top: 11px;
                            left: 0;
                        }
                        .empty-text{
                            width: 262px;
                            font-size: 18px;
                            position: relative;
                            color: #A5A5A5;
                            margin: 15px auto 19px auto;
                        }
                        .empty-tip{
                            text-align: center;
                            font-size: 18px;
                            color: #2996F3;
                            width: 300px;
                            margin: 0 auto;
                            position: relative;
                            .empty-scan-icon{
                                width: 28px;
                                position: absolute;
                                top: 2px;
                                right: 15px;
                            }
                        }
                    }
                }
            }
        }
        .scan-list-footer{
            height: 70px;
            position: relative;
            background:rgba(255,255,255,1);
            box-shadow:0 0 20px 0 rgba(0,0,0,0.15);
            .scan-list-center{
                max-width: 1200px;
                margin: 0 auto;
                height: 100%;
                box-sizing: border-box;
                padding: 0 10px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .scan-foot-left{
                    .scan-info{
                        color: #333333;
                        font-size: 16px;
                        margin-right: 40px;
                        .scan-info-part{
                            margin-left: 3px;
                        }
                        .scan-info-point{
                            width:7px;
                            height:7px;
                            background:rgba(41,150,243,1);
                            display: inline-block;
                            margin-right: 7px;
                            vertical-align: middle;
                            border-radius: 50%;
                        }
                        .scan-point-y{
                            background: #F6AA32;
                        }
                        .scan-info-num{
                            font-size: 31px;
                            color: #2996F3;
                        }
                        .scan-info-percent{
                            color: #2996F3;
                        }
                        .scan-num-y{
                            color: #F6AA32;
                        }
                    }
                    .scan-type:nth-child(4){
                        margin-left: 22px;
                        margin-right: 40px;
                    }
                    .scan-type{
                        display: inline-block;
                        .span-type-title{
                            font-size: 16px;
                            margin-right: 13px;
                            color: #333333;
                        }
                        .span-type-content{
                            background: #ECECEC;
                            border-radius: 6px;
                            display: inline-block;
                            .span-type-option{
                                display: inline-block;
                                width:78px;
                                height:24px;
                                background:#ECECEC;
                                border-radius:6px;
                                color: #9F9F9F;
                                font-size: 14px;
                                line-height: 24px;
                                cursor: pointer;
                            }
                            .span-type-option-active{
                                color: white;
                                background: #2996F3;
                            }
                        }
                    }
                }
                .scan-btn{
                    font-size:16px;
                    font-family:PingFangSC-Medium;
                    font-weight:500;
                    color:rgba(255,255,255,1);
                    width:98px;
                    height:37px;
                    background:rgba(41,150,243,1);
                    border-radius:5px;
                    border: none;
                }
            }
        }
    }
    .scan-list  /deep/ .student-code{
        width:462px;
        text-align: left;
        background:rgba(255,255,255,1);
        box-shadow:0 0 20px 0 rgba(0,0,0,0.15);
        border-radius:17px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        .el-dialog__header{
            display: none;
        }
        .el-dialog__body{
            padding: 50px 30px 30px;
            .code-row{
                display: flex;
                align-items: center;
                .code-row-name{
                    margin-right: 21px;
                    white-space: nowrap;
                }
                .code-row-input::placeholder{
                    color: #C0C0C0;
                }
                .code-row-input{
                    width: calc(100% - 50px);
                    height: 40px;
                    padding-left: 17px;
                    border-radius:5px;
                    font-size: 14px;
                    border:1px solid rgba(224,224,224,1);
                    color: #333333;
                }
            }
            .code-footer{
                margin-top: 35px;
                overflow: hidden;
                .code-btn{
                    height: 36px;
                    cursor: pointer;
                    border: none;
                    border-radius: 3px;
                    font-size: 16px;
                    font-weight: 500;
                    padding: 0 32px;
                    float: right;
                }
                .code-submit{
                    color: white;
                    background: #2996F3;
                }
                .code-cancel{
                    color: #2996F3;
                    background: white;
                    border: 1px solid #2996F3;
                    margin-left: 20px;
                }
            }
        }
    }
    .scan-list  /deep/ .student-paper{
        width:462px;
        text-align: center;
        background:rgba(255,255,255,1);
        box-shadow:0 0 20px 0 rgba(0,0,0,0.15);
        border-radius:17px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        .el-dialog__header{
            display: none;
        }
        .el-dialog__body{
            padding: 56px 40px 30px 40px;
            .paper-img{
                width: 102px;
                height: 138px;
            }
            .paper-title{
                margin-top: 29px;
                font-size: 16px;
                color: #333333;
                text-align: left;
                line-height: 22px;
                .paper-title-name{
                    color: #2996F3;
                    word-break: break-all;
                }
                .paper-name-list{
                    margin-top: 10px;
                    .paper-name-select{
                        width: 100%;
                    }
                }
            }
            .paper-page-title{
                margin-top: 21px;
                font-size: 16px;
                color: #333333;
                text-align: left;
            }
            .paper-page-content{
                text-align: left;
                .paper-page-option{
                    height:26px;
                    background:rgba(239,239,239,1);
                    border-radius:6px;
                    padding: 0 19px;
                    font-size: 16px;
                    display: inline-block;
                    line-height: 26px;
                    color: #848484;
                    margin-top: 15px;
                    margin-right: 11px;
                    cursor: pointer;
                }
                .paper-page-option-active{
                    background: #2996F3;
                    color: white;
                }
            }
            .paper-footer{
                margin-top: 40px;
                overflow: hidden;
                .paper-btn{
                    height: 36px;
                    cursor: pointer;
                    border: none;
                    border-radius: 3px;
                    font-size: 16px;
                    font-weight: 500;
                    padding: 0 32px;
                }
                .paper-submit{
                    color: white;
                    background: #2996F3;
                }
                .paper-cancel{
                    color: #2996F3;
                    background: white;
                    border: 1px solid #2996F3;
                    margin-left: 20px;
                }
            }
        }
    }
    .scan-list  /deep/ .set-paper{
        width:462px;
        text-align: center;
        background:rgba(255,255,255,1);
        box-shadow:0 0 20px 0 rgba(0,0,0,0.15);
        border-radius:17px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        .el-dialog__header{
            display: none;
        }
        .el-dialog__body{
            padding: 56px 40px 30px 40px;
            .set-paper-img{
                width: 182px;
                height: 160px;
            }
            .set-paper-title{
                margin-top: 8px;
                font-size: 16px;
                color: #333333;
            }
            .set-paper-tip{
                margin-top: 10px;
                font-size: 14px;
                color: #A2A2A2;
            }
            .set-paper-footer{
                margin-top: 32px;
                overflow: hidden;
                .set-paper-btn{
                    height: 36px;
                    cursor: pointer;
                    border: none;
                    border-radius: 3px;
                    font-size: 16px;
                    font-weight: 500;
                    padding: 0 32px;
                }
                .set-paper-submit{
                    color: white;
                    background: #2996F3;
                }
                .set-paper-cancel{
                    color: #2996F3;
                    background: white;
                    border: 1px solid #2996F3;
                    margin-left: 20px;
                }
            }
        }
    }
    .scan-list  /deep/ .scan-loading{
        width:462px;
        text-align: center;
        background:rgba(255,255,255,1);
        box-shadow:0 0 20px 0 rgba(0,0,0,0.15);
        border-radius:17px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        .el-dialog__header{
            display: none;
        }
        .el-dialog__body{
            padding: 18px 40px 30px 40px;
            .scan-loading-img{
                width: 205px;
                height: 172px;
            }
            .scan-loading-title{
                margin-top: 8px;
                font-size: 16px;
                color: #333333;
            }
            .scan-loading-tip{
                margin-top: 10px;
                font-size: 20px;
                color: #2996F3;
            }
        }
    }
</style>
